export const scheduledCamp = (builder) => ({
    scheduledCamp: builder.mutation({
        query: ({ page, limit, campaignType, search, status, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/scheduledCampaignLogs',
                method: 'GET',
                params: { page, limit, campaignType, search, status, startDate, endDate },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});